// extracted by mini-css-extract-plugin
module.exports = {"root":"header-module--root--2uc4w","section":"header-module--section--2x7py"};